import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    IconChevronDown,
    IconChevronUp,
    Text,
} from '@zillow/constellation';
import { IconifiedList, IconCheck, IconRadioDeselected } from '@zillow/zrs-comet';
import { StyledTextButtonNoUnderline } from 'app/shared/StyledComponents/StyledComponents';

const WhoHasSignedDescription = ({ text, signeeList }) => {
    const [isDropdownEnabled, setDropdownEnabled] = useState(false);

    const getIconifiedListItems = list => list.map(({ text: signeeText, type }) => ({
        icon: type === 'unsigned' ? <IconRadioDeselected /> : <IconCheck />,
        primaryContent: <Text fontType="bodySmall">{ signeeText }</Text>,
    }));

    return (
        <div className="WhoHasSignedDescription" data-test="connected-leases-who-has-signed-description">
            <StyledTextButtonNoUnderline
                paddingTop={0.5}
                fontType="bodySmallHeading"
                marginBottom="sm"
                mediaQuery={{
                    xl: {
                        marginBottom: 'sm',
                    },
                }}
                onClick={() => setDropdownEnabled(!isDropdownEnabled)}
                applyOnHover={true}
                icon={isDropdownEnabled ? <IconChevronUp /> : <IconChevronDown />}
                iconPosition="end"
                iconSize="xs"
            >
                {text}
            </StyledTextButtonNoUnderline>
            {isDropdownEnabled && (
                <IconifiedList
                    backgroundColor="white"
                    iconSize="sm"
                    listItems={getIconifiedListItems(signeeList)}
                />
            )}
        </div>
    );
};

WhoHasSignedDescription.propTypes = {
    text: PropTypes.string.isRequired,
    signeeList: PropTypes.arrayOf(PropTypes.shape({
        type: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
    })).isRequired,
};

export default WhoHasSignedDescription;
